import type { BoxProps } from '@shopify/polaris';
import type { IInfoPanelGroup } from '../types';

import { GInfoPanelSingleItem } from './GInfoPanelSingleItem';
import { Box, BlockStack, Text } from '@shopify/polaris';

interface GInfoPanelGroupItemProps {
  group: IInfoPanelGroup;
  selectedId?: string;
  groupId?: number;
  hideLabel?: boolean;
  selectedBackground?: BoxProps['background'];
  onSelect: (id: string) => void;
  onHover?: (id: string) => void;
}

export const GInfoPanelGroupItem: React.FC<GInfoPanelGroupItemProps> = ({
  group,
  selectedId,
  hideLabel = false,
  onSelect,
  onHover,
}) => {
  return (
    <BlockStack gap="100">
      {!hideLabel && (
        <Box paddingInline="400">
          <Text as="p" variant="headingMd" fontWeight="semibold">
            {group.groupLabel}
          </Text>
        </Box>
      )}
      <Box paddingInline="150">
        <BlockStack gap="0">
          {group.items.map((item) => (
            <GInfoPanelSingleItem
              key={item.id}
              item={item}
              isSelected={selectedId === item.id}
              onSelect={onSelect}
              onHover={onHover}
            />
          ))}
        </BlockStack>
      </Box>
    </BlockStack>
  );
};
